/*******************************************
 * Victor Rybakov
 * 12 Oct 2017
 * Import resources: from standard JSON file + binary files
 * ResourcesImport.tsx
 *******************************************/

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { store as RMStore, actions as RMActions } from '../../../../pdc-widget-resource-manager/src/ts/flux/glob';

declare let window: any;

import { IGlob } from '../../ts/Glob';
import { TableSelect, ITableOptions } from './TableSelect';
import DirResourceTree from '../../../../pdc-widget-resource-manager/src/ts/react/DirResourceTree';
const JSZip = require('jszip');
export default class ResourcesImport extends React.Component<
    {
        value;
        input;
        importFileName;
        options;
        onChange(value);
        glob: IGlob;
    },
    any
> {
    //LL: 03.20.25
    private references: {
        resourcesInput?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
        let items = {},
            dir = null;
        if (this.props.value) {
            items = this.props.value.checkedList;
            dir = this.props.value.dirid;
        }

        this.state = _.extend(
            {},
            this.getState(this.props.options), //..input
            {
                value: {
                    items: items,
                    dir: dir
                }
            }
        );
    }

    selectFolderDef;
    INSTANCE_ID = 'resources-export';

    componentDidMount() {
        if (this.props.value == null) {
            this.passChange(this.state.value);
        }

        if (_.isEmpty(RMStore.glob)) {
            RMStore.glob = window['pdc'].platform.glob;
        }

        RMStore.addChangeListener(this._onChange);
        RMActions.getResourceTreeRoot(this.INSTANCE_ID);
    }

    componentWillUnmount() {
        if (this.selectFolderDef != null) {
            this.selectFolderDef.reject();
            delete this.selectFolderDef;
        }
        RMStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        if (this.state.RMState.resourceTreeRootDirId !== -1 && this.state.selectedDirId === -1) {
            this.setState(
                _.extend(this.getState(this.props.options), {
                    selectedDirId: this.state.RMState.resourceTreeRootDirId,
                    dirTreeInstanceId: this.INSTANCE_ID //'resource-tree-' + this.state.RMState.resourceTreeRootDirId
                })
            );
        } else {
            this.setState(this.getState(this.props.options));
        }
    };

    getState = (input) => {
        const valuesHash = _.reduce(
            input,
            function (hash, obj, i) {
                //obj['inputFile'] = 'n/a';
                hash[i] = obj; //{name: obj, data: {}};  //
                return hash;
            },
            {}
        );

        const values = _.range(input.length).map(function (i) {
            return i.toString();
        });

        const RMState = RMStore.getInstanceState(this.INSTANCE_ID);

        return {
            RMState,
            valuesHash: valuesHash,
            values: values,
            displayKey: 'name'
        };
    };

    getKeyList = (value) => {
        const self = this;
        return _.chain(value)
            .map(function (value, key) {
                return self.state.valuesHash[key];
            })
            .compact()
            .value();
    };

    passChange = (value, listFiles = null) => {
        if (typeof this.props.onChange === 'function') {
            if (listFiles == null) {
                listFiles = this.state.listResFiles; // like: { GUID1: file1, GUID2: file2 }
            }

            let _keyListTemplates = this.getKeyList(value.items);
            this.props.onChange({
                zipFile: value.zipFile,
                keyList: _keyListTemplates,
                dirid: value.dir,
                listResFiles: listFiles,
                checkedList: value.items
            });
        }
    };

    componentWillReceiveProps(nextProps) {
        this.setState(this.getState(nextProps.options));
    }

    handleValueChange = (obj) => {
        const value = _.clone(this.state.value);
        value.items = obj;

        this.passChange(value);
        this.setState({
            value: value
        });
    };

    handleDirChange = (id) => {
        const value = _.clone(this.state.value);
        value.dir = id;

        this.passChange(value);
        this.setState({
            value: value
        });
    };

    getPath = (id) => {
        let instanceDirStore = 'resource-tree-popup' + this.state.RMState.selectedDirId.toString();
        const data = this.props.glob.DirsStore._state.data[instanceDirStore];

        if (data == null || data.data == null) {
            return [];
        }

        let obj = data.data.dirsHash[id];
        const arr = [];

        while (obj != null) {
            arr.unshift(obj.name);
            obj = obj.parent;
        }

        return arr;
    };

    // get Input Resources Files:
    handleResourceChange = (e) => {
        let file = e.target.files[0];

        if (file == null) {
            return;
        }

        let listFiles = this.state.listResFiles || {};

        JSZip.loadAsync(file) // 1) read the Blob
            .then(
                (zip) => {
                    zip.forEach(function (relativePath, zipEntry) {
                        let guid = ResourcesImport.getFileGuidName(zipEntry.name);
                        listFiles[guid] = { name: zipEntry.name, size: zipEntry._data.uncompressedSize };
                    });

                    const value = _.clone(this.state.value);
                    value.zipFile = file;
                    this.passChange(value, listFiles);
                    this.setState({
                        listResFiles: listFiles,
                        value: value
                    });
                },
                (e) => {
                    this.props.glob.AppActions.showNotification_Fail(
                        'Error reading ' + file.name + ': ' + e.message,
                        null,
                        {
                            manualDestroy: true
                        }
                    );
                }
            );
    };

    static getFileGuidName(fileName: string) {
        const guidExtractorRegex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
        const guidsFound = fileName.match(guidExtractorRegex);
        if (guidsFound.length === 1) {
            return '{' + guidsFound[0] + '}';
        } else {
            return '';
        }
    }

    static getFileDataExtension(fileName: string) {
        let index1 = fileName.lastIndexOf('-');
        let index2 = fileName.lastIndexOf('.');

        if (index1 > 0 && index2 > index1 && index2 - index1 === 14) {
            return '.DAT-' + fileName.substring(index1 + 1, index2);
        }
        return '';
    }

    selectInputResources = () => {
        let resourcesInput = this.references.resourcesInput as HTMLInputElement;
        if (resourcesInput == null) {
            return;
        }
        resourcesInput.click();
    };

    selectFolder = () => {
        const def = $.Deferred();

        this.props.glob.DialogActions.createDialog(
            'Select destination folder for imported Resources',
            '',
            function (dirid) {
                def.resolve(dirid);
            },
            function () {
                def.reject();
            },
            function () {
                def.reject();
            },
            'custom',
            {
                deny: false,
                confirmTitle: 'OK',

                Component: DirResourceTree,
                componentOptions: {
                    glob: this.props.glob,
                    instanceId: 'resources-export',
                    root_dirid: this.state.RMState.selectedDirId
                }
            }
        );

        const self = this;

        def.done(function (id) {
            self.handleDirChange(id);
        });

        if (this.selectFolderDef != null) {
            this.selectFolderDef.reject();
        }

        this.selectFolderDef = def;
    };

    private static formatBytes(bytes, decimals) {
        let SIZES = ['Bytes', 'KBytes', 'MBytes', 'GBytes', 'TBytes', 'PBytes', 'EBytes', 'ZBytes', 'YBytes'];
        for (var i = 0, r = bytes, b = 1024; r > b; i++) {
            r /= b;
        }
        return `${parseFloat(r.toFixed(decimals))} ${SIZES[i]}`;
    }

    render() {
        let hash = _.each(this.state.valuesHash, (item: any) => {
            item['fileGUID'] = item.data.GUID;

            if (this.state.listResFiles != null && this.state.listResFiles[item.data.GUID] != null) {
                item['inputFile'] = this.state.listResFiles[item.data.GUID].name;
                item['fileSize'] = ResourcesImport.formatBytes(this.state.listResFiles[item.data.GUID].size, 2);
            }
        });

        const tableOptions: ITableOptions = {
            value: this.state.value.items,
            values: this.state.values,
            valuesHash: hash, //this.state.valuesHash,
            displayKey: this.state.displayKey,

            onChange: this.handleValueChange
        };

        let targetMessage: any = ['Select Target Folder'];
        if (this.state.value.dir != null) {
            targetMessage = [
                <span key="res-icon" className="glyphicon glyphicon-remove"></span>,
                '\\' + this.getPath(this.state.value.dir).join('\\')
            ];
        }

        let inputResourceMessage: any[];

        if (this.state.listResFiles != null) {
            inputResourceMessage = [
                'Selected',
                <b key="res-c1"> {this.getKeyList(this.state.value.items).length.toString()}</b>,
                ' of ',
                <b key="res-c2"> {_.pluck(this.state.listResFiles, 'name').length.toString()}</b>,
                ' file(s)'
            ];
        } else {
            inputResourceMessage = ['Select Resource Data Archive'];
        }

        return (
            <div className="workspaces-import">
                <div style={{ display: '-webkit-box' }}>
                    <div className="target-folder-select">
                        <div className="btn btn-default" onClick={this.selectFolder}>
                            {targetMessage}
                        </div>
                    </div>

                    <div className="target-folder-select">
                        <div className="btn btn-default" onClick={this.selectInputResources}>
                            {inputResourceMessage}
                        </div>
                    </div>
                    <div className="select-files-by-guid-notes">
                        {'Please select ZIP archive which contains Resource Data'}
                    </div>
                    <input
                        ref={(input) => {
                            this.references.resourcesInput = input;
                        }} //LL: 03.20.25
                        accept={'.zip'}
                        type="file"
                        className="invisible"
                        hidden={true}
                        name="resourcesInput"
                        multiple={false}
                        onChange={this.handleResourceChange}
                    />
                </div>

                <div className="table-container">
                    <TableSelect options={tableOptions} showFourthColumn={true} />
                </div>
            </div>
        );
    }
}
